import React, {createContext, useContext} from 'react'

interface GoogleMapsContextValue {
  apiKey: string
}

const GoogleMapsContext = createContext<GoogleMapsContextValue>({apiKey: ''})

interface GoogleMapsProviderProps {
  apiKey: string
  children: React.ReactNode
}

export const GoogleMapsProvider = ({apiKey, children}: GoogleMapsProviderProps) => {
  return <GoogleMapsContext.Provider value={{apiKey}}>{children}</GoogleMapsContext.Provider>
}

export const useGoogleMaps = () => useContext(GoogleMapsContext)
